import { AfterViewInit, Component, ElementRef, OnInit, signal, ViewChild, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModal } from '../services/ziro-modal.service';
import { ZiroIcons } from '../models/ziro-icons.enum';

export interface EulaModalViewProperties {
  html: SafeHtml;
  reviewDate: string;
  slug: string;
}

@Component({
  selector: 'ziro-eula-modal',
  templateUrl: './eula-modal.component.html',
  styleUrl: './eula-modal.component.scss',
  standalone: false,
})
export class EulaModalComponent implements CustomModal<EulaModalViewProperties>, OnInit, AfterViewInit {
  activeModal = inject(NgbActiveModal);

  @ViewChild('modalBody') modalBody: ElementRef;
  ziroIcons = ZiroIcons;
  modalProperties: EulaModalViewProperties;
  html: SafeHtml;
  reviewDate: string;
  base_url = 'https://learn.goziro.com/t/';
  url: string;
  isScrolledToBottom = signal<boolean>(false);

  ngOnInit(): void {
    this.html = this.modalProperties.html;
    this.reviewDate = this.modalProperties.reviewDate;
    this.url = this.base_url + this.modalProperties.slug;
  }

  ngAfterViewInit(): void {
    this._checkIfScrolledToBottom = this._checkIfScrolledToBottom.bind(this);
    this.modalBody.nativeElement.addEventListener('scroll', this._checkIfScrolledToBottom);
  }

  private _checkIfScrolledToBottom(): void {
    const element = this.modalBody.nativeElement;
    if (element.scrollTop >= element.scrollHeight - element.offsetHeight - 10) {
      this.isScrolledToBottom.set(true);
      element.removeEventListener('scroll', this._checkIfScrolledToBottom);
    }
  }

  onAcceptClick(): void {
    this.activeModal.close(true);
  }
}
